/** 绿化分支 **/
import Layout from "@/views/layout/Layout";
// component: () => import("@/views/hrMan/orgPlan/index"),
const examRouter = {
  path: "/greenMan",
  component: Layout,
  redirect: "/examMan/course/list",
  name: "greenMan",
  meta: {
    title: "绿化管理",
    icon: "greenMan",
    roles: ["green_lvhuaguanli_web"],
  },

  children: [
    {
      path: "plantKnowledge",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "plantKnowledge",
      meta: {
        title: "植物知识",
        roles: ["green_zhiwuzhishi_web"],
      },
      children: [
        {
          path: "diseasePestMan",
          component: () =>
            import("@/views/greenMan/plantKnowledge/diseasePestMan/index"),
          name: "diseasePestMan",
          meta: {
            title: "病虫害管理",
            roles: ["green_bingchonghaiguanli_web"],
          },
          children: [],
        },

        {
          path: "seedlingTypeMan",
          component: () =>
            import("@/views/greenMan/plantKnowledge/seedlingTypeMan/index"),
          name: "seedlingTypeMan",
          meta: {
            title: "苗木种类管理",
            roles: ["green_miaomuzhongleiguanli_web"],
          },
          children: [],
        },
      ],
    },

    {
      path: "projectConfig",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "projectConfig",
      meta: {
        title: "项目配置",
        roles: ["green_xiangmupeizhi_web"],
      },
      children: [
        {
          path: "greenItemMan",
          component: () =>
            import("@/views/greenMan/projectConfig/greenItemMan/index"),
          name: "greenItemMan",
          meta: {
            title: "绿化项目管理",
            roles: ["green_lvhuaxiangmuguanli_web"],
          },
          children: [],
        },
        {
          path: "seedlingMan",
          component: () =>
            import("@/views/greenMan/projectConfig/seedlingMan/index"),
          name: "seedlingMan",
          meta: {
            title: "苗木管理",
            roles: ["green_miaomuguanli_web"],
          },
          children: [],
        },
      ],
    },

    {
      path: "maintainMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "maintainMan",
      meta: {
        title: "养护管理",
        roles: ["green_yanghuguanli_web"],
      },
      children: [
        {
          path: "workItemMan",
          component: () =>
            import("@/views/greenMan/maintainMan/workItemMan/index"),
          name: "workItemMan",
          meta: {
            title: "工作项管理",
            roles: ["green_gongzuoxiangguanli_web"],
          },
          children: [],
        },
        {
          path: "taskMake",
          component: () =>
            import("@/views/greenMan/maintainMan/taskMake/index"),
          name: "taskMake",
          meta: {
            title: "任务制定",
            roles: ["green_renwuzhiding_web"],
          },
          children: [],
        },
        {
          path: "taskExecute",
          component: () =>
            import("@/views/greenMan/maintainMan/taskExecute/index"),
          name: "taskExecute",
          meta: {
            title: "任务执行",
            roles: ["green_renwuzhixing_web"],
          },
          children: [],
        },
        {
          path: "taskDisplay",
          component: () =>
            import("@/views/greenMan/maintainMan/taskDisplay/index"),
          name: "taskDisplay",
          meta: {
            title: "任务展示",
            roles: ["green_renwuzhanshi_web"],
          },
          children: [],
        },
        {
          path: "maintainHistory",
          component: () =>
            import("@/views/greenMan/maintainMan/maintainHistory/index"),
          name: "maintainHistory",
          meta: {
            title: "养护记录",
            roles: ["green_yanghujilu_web"],
          },
          children: [],
        },
        {
          path: "statisticalReport",
          component: () =>
            import("@/views/greenMan/maintainMan/statisticalReport/index"),
          name: "statisticalReport",
          meta: {
            title: "统计报表",
            roles: ["green_tongjibaobiao_web"],
          },
          children: [],
        },
      ],
    },

    {
      path: "resourceMan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "resourceMan",
      meta: {
        title: "资源管理",
        roles: ["green_ziyuanguanli_web"],
      },
      children: [
        {
          path: "greenStaffMan",
          // component: () => import("@/views/greenMan/resourceMan/greenStaffMan/index"),
          component: () =>
            import("@/views/greenMan/resourceMan/greenStaffMan/index"),
          name: "greenStaffMan",
          meta: {
            title: "人员管理",
            roles: ["green_renyuanguanli_web"],
          },
          children: [],
        },
        {
          path: "greenDeviceMan",
          // component: () => import("@/views/greenMan/resourceMan/greenStaffMan/index"),
          component: () =>
            import("@/views/greenMan/resourceMan/greenDeviceMan/index"),
          name: "greenDeviceMan",
          meta: {
            title: "设备管理",
            roles: ["green_shebeianquan_web"],
          },
          children: [],
        },
      ],
    },

    //
  ],
};

export default examRouter;
